import { Icon } from 'ui';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import ChatButton from '../ChatButton';
import DiagramMermaid from '../DiagramMermaid/DiagramMermaid';
import './ChatMermaidCard.scss';

function ChatMermaidCard({ conversationId, mermaidCode, messageId, onOpen, t, title }) {
  const [hasError, setHasError] = useState(false);

  function handleApplyStyles(svgElement) {
    // Hacer el SVG más pequeño para el preview
    svgElement.style.maxWidth = '100%';
  }

  function handleError() {
    setHasError(true);
  }

  function handleSuccess() {
    setHasError(false);
  }

  function handleCardClick() {
    onOpen(mermaidCode, title);
  }

  return (
    <div className={`chat-mermaid-card ${hasError ? 'chat-mermaid-card--error' : ''}`} onClick={hasError ? undefined : handleCardClick}>
      <div className="chat-mermaid-card__preview">
        <DiagramMermaid
          applyStyles={handleApplyStyles}
          className="chat-mermaid-card__diagram"
          conversationId={conversationId}
          delay={100}
          mermaidCode={mermaidCode}
          messageId={messageId}
          onError={handleError}
          onSuccess={handleSuccess}
          t={t}
        />
      </div>
      {!hasError && (
        <div className="chat-mermaid-card__footer chat-mermaid-card__footer__content">
          <div className="chat-mermaid-card__footer__title">
            <Icon name="diagram" color="black" size="default" />
            {title || t('chatbot:Diagram')}
          </div>
          <ChatButton className="chat-mermaid-card__footer__button" variant="text">
            <span>{t('chatbot:View')}</span>
          </ChatButton>
        </div>
      )}
    </div>
  );
}

ChatMermaidCard.propTypes = {
  conversationId: PropTypes.string,
  mermaidCode: PropTypes.string.isRequired,
  messageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onOpen: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
};

ChatMermaidCard.defaultProps = {
  conversationId: null,
  messageId: null,
  title: '',
};

export default withTranslation(['chatbot'])(ChatMermaidCard);
